import styled from "styled-components";
import { Link } from "react-router-dom";

export const ContainerMainInfoReferral = styled("div")`
  display: flex;
  justify-content: center;
  flex-direction: column;
  .referral-title {
    transform: translatey(6rem);
    @media screen and (max-width: 576px) {
      transform: translateY(4rem);
    }
  }
  strong {
    font-weight: 900;
    font-size: var(--font-size-xl);
    color: #ffb54a;
    &:first-of-type {
      color: var(--blue-color-dark);
    }
  }
  .referral-detail {
    font-weight: 500;
    font-size: var(--font-size-base);
    color: var(--text-color-dark);
    @media screen and (max-width: 768px) {
      font-size: var(--font-size-sm);
    }
  }
`;
export const ImageReferral = styled("img")`
  @media screen and (max-width: 768px) {
    width: 80%;
  }
`;
export const ContainerCode = styled("div")`
  height: 60px;
  max-width: 300px;
  color: var(--field-color);
  border: 1px solid var(--blue-color-dark);
  border-radius: var(--border-radius-2);
  background: var(--button-color-labs);
  margin: 0 auto;
  padding: 7px 15px;
  text-align: center;
  font-weight: 500;
  font-size: 22px;
  @media screen and (max-width: 768px) {
    font-size: var(--font-size-lg);
  }
`;
export const ContainerHistoryReferral = styled("div")`
  margin-top: 40px;
  .caption {
    font-size: var(--font-size-md);
    max-width: 700px;
    @media screen and (max-width: 768px) {
      font-weight: 500;
      font-size: var(--font-size-sm);
      color: var(--text-color-dark);
      width: 100%;
    }
  }
`;
export const HeaderHistoryReferral = styled("div")`
  margin-bottom: 10px;
  text-align: center;
  font-weight: 300;
  font-size: var(--font-size-xl);
  color: #0b457e;
  @media screen and (max-width: 768px) {
    font-weight: 500;
    font-size: var(--font-size-lg);
  }
`;
export const ContainerInfoHistoryReferral = styled("div")`
  margin: 10px;
  max-width: 390px;
  border-radius: 36px;
  background: #b0e1fb;
  min-height: 230px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  padding: 20px 3rem;
  @media screen and (max-width: 768px) {
    padding: 1rem;
  }
  .card-content {
    font-weight: 500;
    font-size: var(--font-size-base);
    color: var(--text-color-dark);
    @media screen and (max-width: 576px) {
      font-size: var(--font-size-sm);
    }
  }
  .card-details {
    font-weight: 500;
    font-size: 22px;
    color: var(--blue-color-dark);
    @media screen and (max-width: 576px) {
      font-size: var(--font-size-base);
    }
  }
  a {
    font-size: var(--font-size-sm);
    line-height: 22px;
    color: var(--blue-color-dark);
  }
`;

export const LinkDetailReferral = styled(Link)`
  color: var(--blue-color-dark);
`;
